import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'antd';
import { Query } from 'react-apollo';
import Link from '../../components/general/Link';

import AllEdlCollegesQuery from '../../graphql/queries/allEdlCollegesQuery.graphql';
import NewEdlCourseModalForm from '../../modalForms/NewEdlCourseModalForm';

const { Column } = Table;

class EdlAllColleges extends Component {
  state = {
    newCourseModalVisible: false,
    newCourseCollegeId: null,
  };

  closeNewCourseModal = () => {
    this.setState({
      newCourseModalVisible: false,
      newCourseCollegeId: null,
    });
  };

  render() {
    const { match } = this.props;
    const { newCourseCollegeId, newCourseModalVisible } = this.state;
    return (
      <div className="contentBox">
        <NewEdlCourseModalForm
          visible={newCourseModalVisible}
          edlCollegeId={newCourseCollegeId}
          closeModal={this.closeNewCourseModal}
        />
        <h1>All Colleges</h1>
        <div style={{ marginBottom: 30 }}>
          <Link to={`${match.url}/create`}>
            <Button type="primary">Add new college</Button>
          </Link>
        </div>
        <Query query={AllEdlCollegesQuery} fetchPolicy="network-only">
          {({ loading, error, data }) => {
            if (error) return `Error! ${error.message}`;

            const { colleges } = data;
            return (
              <Table dataSource={colleges} loading={loading} rowKey="id" bordered>
                <Column title="College Name" dataIndex="name" key="name" />
                <Column
                  title="Address"
                  key="address"
                  render={(text, record) => (
                    <Fragment>
                      <span>{record.address}</span>
                      <br />
                      <span>
                        {record.city}, {record.state} - {record.pincode}
                      </span>
                    </Fragment>
                  )}
                />
                <Column
                  title="Courses"
                  key="courses"
                  width="50%"
                  render={(text, record) =>
                    record.courses.map((entry) => (
                      <p style={{ marginBottom: 2 }} key={entry.id}>
                        {entry.name} ({entry.durationYears} years)
                      </p>
                    ))
                  }
                />
                <Column
                  title="Actions"
                  key="actions"
                  render={(text, record) => (
                    <Fragment>
                      <Button
                        htmlType="button"
                        onClick={() => {
                          this.setState({
                            newCourseModalVisible: true,
                            newCourseCollegeId: record.id,
                          });
                        }}
                      >
                        Add new Course
                      </Button>
                    </Fragment>
                  )}
                />
              </Table>
            );
          }}
        </Query>
      </div>
    );
  }
}

EdlAllColleges.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default EdlAllColleges;



// WEBPACK FOOTER //
// ./src/pages/edl/EdlAllColleges.jsx